import styled from 'styled-components';

export const Layer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background-color: rgb(255 255 255);
  overflow: hidden;
`
